module.exports = __webpack_public_path__ + "eef0dc8877bde62e8d5fa120ef0263c3.png";